import axios from "axios";

// Pick the right API base URL.
//
// REACT_APP_BACKEND_URL is baked into the build at CI time and points at the
// Emergent preview/production host. When the app is served from a *different*
// origin (e.g. a custom domain like https://app.relaxedrijk.nl), calling that
// baked URL would be a cross-origin request — CORS would have to allow it and
// the auth cookie (SameSite=Lax) would not be sent. Both of those problems
// disappear if we just call the same origin: Emergent's ingress routes any
// /api/* path to the backend on the same pod.
//
// So: when the current page origin is the same as the baked URL (or we are
// running locally / can't tell), use the baked URL as-is. Otherwise fall back
// to same-origin "" so axios calls "/api/...".
function pickBaseUrl() {
  const baked = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined" || !baked) return baked;
  try {
    const bakedOrigin = new URL(baked).origin;
    if (bakedOrigin === window.location.origin) return baked;
    // Different origin → use relative /api on the current host.
    return "";
  } catch {
    return baked;
  }
}

const BACKEND_URL = pickBaseUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
